import type { ReactElement, ReactNode } from 'react';
import cx from 'clsx';
import { Header, ListBoxSection, type ListBoxSectionProps } from 'react-aria-components';
import styles from './option-group.module.css';

interface OptionGroupProps<T extends object> extends Omit<ListBoxSectionProps<T>, 'children'> {
  label?: string | ReactNode;
  children?: ReactNode;
  labelClassName?: string;
}

export function OptionGroup<T extends object>({
  label,
  labelClassName = 'body-standard',
  children,
  ...props
}: OptionGroupProps<T>): ReactElement {
  return (
    <ListBoxSection {...props}>
      {label ? <Header className={cx(styles.label, labelClassName)}>{label}</Header> : null}
      {children}
    </ListBoxSection>
  );
}
